// src/utils/rankConstants.js
import BronzeEmblem from '../assets/emblems/Bronze.png';
import SilverEmblem from '../assets/emblems/Silver.png';
import GoldEmblem from '../assets/emblems/Gold.png';
import IronEmblem from '../assets/emblems/Iron.png';
import EmeraldEmblem from '../assets/emblems/Emerald.png';
import PlatinumEmblem from '../assets/emblems/Platinum.png';
import DiamondEmblem from '../assets/emblems/Diamond.png';

export const RANK_IMAGES = {
  BRONZE: BronzeEmblem,
  SILVER: SilverEmblem,
  GOLD: GoldEmblem,
  IRON: IronEmblem,
  EMERALD: EmeraldEmblem,
  PLATINUM: PlatinumEmblem,
  DIAMOND: DiamondEmblem,
};

export const RANK_ORDER = ['DIAMOND', 'EMERALD', 'PLATINUM', 'GOLD', 'SILVER', 'BRONZE', 'IRON'];
